export default __webpack_public_path__ + "static/media/cfc-seal.7988a841.png";